module.exports = __webpack_public_path__ + "img/instructor.41071309.webp";